import { Button, Grid, makeStyles, CircularProgress, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useContext } from 'react';
import { SecondaryButton } from '../FormInput';
import { CustomeSignPad } from '../SignaturePad';
import { UserMessageSignatures_AddUpdate } from '../Service/userDetails-service';
import AppContext from '../../App/AppContext';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',

        [theme.breakpoints.down('sm')]: {
            overflow: 'auto' // takes at least 40% of screen height
        }
    },
    scrollSection: {
        flex: 1,
        overflowY: 'auto',
        // padding: theme.spacing(1),

        // ✅ ensure min height for mobile
        [theme.breakpoints.down('sm')]: {
            height: '100vh' // takes at least 40% of screen height
        }
        // [theme.breakpoints.up('md')]: {
        //     minHeight: '60vh' // more space on larger screens
        // }
    },
    footer: {
        borderTop: '1px solid #ddd',
        padding: theme.spacing(1),
        background: '#fff',
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        [theme.breakpoints.down('sm')]: {
            position: 'relative'
        }
    },
    button: {
        borderRadius: 8,
        fontWeight: 600,
        height: 44,
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.8rem'
        }
    },
    errorText: {
        color: 'red',
        marginTop: theme.spacing(1)
    }
}));

export const UserMsgModal = ({ message, onClose, onCancelAll }) => {
    const { showToast } = useContext(AppContext);
    const classes = useStyles();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [userSignature, setUserSignature] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleSubmit = async () => {
        if (!userSignature) {
            setError('Please provide a signature before submitting.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const data = {
                messageID: message.messageID,
                userSignature: userSignature
            };

            let res = await UserMessageSignatures_AddUpdate(data);

            if (res?.success) {
                onClose();
                showToast(res?.data?.message || 'Message acknowledged successfully');
                setUserSignature(null);
            } else {
                setError(res?.message || 'Something went wrong. Please try again.');
            }
        } catch (err) {
            setError(err.message || 'Network error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={classes.root}>
            {/* Scrollable Content */}
            <div className={classes.scrollSection}>
                <div dangerouslySetInnerHTML={{ __html: message.messageDescription }} />
                {error && <div className={classes.errorText}>{error}</div>}
            </div>

            {/* Fixed Footer */}
            <div className={classes.footer}>
                <CustomeSignPad
                    onChange={(sig) => setUserSignature(sig.userSignature)}
                    content="Signature"
                    name="userSignature"
                    clearSig={() => setUserSignature(null)}
                />

                {/* Responsive Buttons */}
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <SecondaryButton onClick={handleSubmit} fullWidth className={classes.button} disabled={!userSignature || loading}>
                            {loading ? <CircularProgress size={24} /> : 'Submit'}
                        </SecondaryButton>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button onClick={onClose} fullWidth variant="outlined" color="secondary" className={classes.button} disabled={loading}>
                            Cancel
                        </Button>
                    </Grid>
                    {/* <Grid item xs={12} sm={4}>
                        <Button onClick={onCancelAll} fullWidth variant="outlined" color="default" className={classes.button} disabled={loading}>
                            Cancel All
                        </Button>
                    </Grid> */}
                </Grid>
            </div>
        </div>
    );
};
